import { GET_REVISIONS_LIST_SUCCEEDED } from "editor/actions/revisions";
import { EDITOR_SAVE_SUCCESS } from "editor/actions/status";
import { INITIALIZE_FORM } from "editor/actions/form";

const initialState = {
  list: [],
  requestRevisions: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_REVISIONS_LIST_SUCCEEDED:
      return {
        ...state,
        list: action.payload,
        requestRevisions: false,
      };
    case EDITOR_SAVE_SUCCESS:
      return {
        ...state,
        requestRevisions: true,
      };
    case INITIALIZE_FORM:
      return initialState;
    default:
      return state;
  }
};
